import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  type FirestoreSectionAssignmentConversationPromptTest,
  empty,
} from '../firestore/SectionAssignmentConversationPromptTest/schema'

export class SectionAssignmentConversationPromptTest extends ObservableModelWithDecorators<FirestoreSectionAssignmentConversationPromptTest> {
  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSectionAssignmentConversationPromptTest>
  ) {
    super(repository, doc)
  }

  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }
}
